import { Sentry } from 'lib-shared-sentry';
import Visibility from 'visibilityjs';

import { history } from 'bootstrap.store';

import * as conversationsActions from '../../../components/conversation/actions/conversations';

import { actions } from './actions/visibility';

const { visibilityStart, visibilityHidden, visibilityShown, visibilityStop } =
  actions;
const { conversationsResetUnread } = conversationsActions.actions;
export const visibilityMiddleware = () => (store) => {
  const next = store.dispatch;
  let listener: number | boolean | null = null;

  const initVisibility = () => {
    listener = Visibility.change(() => {
      if (Visibility.hidden()) {
        let csid: number | null = null;
        // We look the the pathname to see if we are on conversation/{csid}.
        if (history.location?.pathname?.indexOf('conversation/') > -1) {
          // Get the csid from the pathname.
          const pathnameArr = history.location.pathname.split('/conversation/');
          if (pathnameArr.length > 0) {
            csid = parseInt(pathnameArr[1]);
          }
        }
        next(visibilityHidden({ csid: csid }));
      } else {
        const state = store.getState();
        let csid: number | null = null;
        // We look the the pathname to see if we are on conversation/{csid}.
        if (history.location?.pathname?.indexOf('conversation/') > -1) {
          // Get the csid from the pathname.
          const pathnameArr = history.location.pathname.split('/conversation/');
          if (pathnameArr.length > 0) {
            csid = parseInt(pathnameArr[1]);
            // match the state conversation csid with current path.
            if (
              isNaN(csid) === false &&
              state.conversation.metaConversation.conversation.id === csid
            ) {
              next(conversationsResetUnread({ csid: csid }));
            }
          }
        }
        next(visibilityShown({ csid: csid }));
      }
    });
    document.addEventListener('mouseleave', _mouseleave, false);
    document.addEventListener('mouseenter', _mouseenter, false);
    window.addEventListener('focus', _focusListener, false);
    window.addEventListener('blur', _blurListener, false);
  };

  const removeVisibility = () => {
    Visibility.unbind(listener as number);
    document.removeEventListener('mouseleave', _mouseleave, false);
    document.removeEventListener('mouseenter', _mouseenter, false);
    window.removeEventListener('focus', _focusListener, false);
    window.removeEventListener('blur', _blurListener, false);
  };

  const _mouseleave = () => {
    next(visibilityHidden());
  };

  const _mouseenter = () => {
    const state = store.getState();
    let csid: number | null = null;
    // We look the the pathname to see if we are on conversation/{csid}.
    if (history.location?.pathname?.indexOf('conversation/') > -1) {
      // Get the csid from the pathname.
      const pathnameArr = history.location.pathname.split('/conversation/');
      if (pathnameArr.length > 0) {
        csid = parseInt(pathnameArr[1]);
        // match the state conversation csid with current path.
        if (
          isNaN(csid) === false &&
          state.conversation.metaConversation.conversation.id === csid
        ) {
          next(conversationsResetUnread({ csid: csid }));
        }
      }
    }
    next(visibilityShown({ csid: csid }));
  };

  const _focusListener = () => {
    const state = store.getState();
    let csid: number | null = null;
    // We look the the pathname to see if we are on conversation/{csid}.
    if (history.location?.pathname?.indexOf('conversation/') > -1) {
      // Get the csid from the pathname.
      const pathnameArr = history.location.pathname.split('/conversation/');
      if (pathnameArr.length > 0) {
        csid = parseInt(pathnameArr[1]);
        // match the state conversation csid with current path.
        if (
          isNaN(csid) === false &&
          state.conversation.metaConversation.conversation.id === csid
        ) {
          next(conversationsResetUnread({ csid: csid }));
        }
      }
    }
    next(visibilityShown({ csid: csid }));
  };

  const _blurListener = () => {
    let csid: number | null = null;
    // We look the the pathname to see if we are on conversation/{csid}.
    if (history.location?.pathname?.indexOf('conversation/') > -1) {
      // Get the csid from the pathname.
      const pathnameArr = history.location.pathname.split('/conversation/');
      if (pathnameArr.length > 0) {
        csid = parseInt(pathnameArr[1]);
      }
    }
    next(visibilityHidden({ csid: csid }));
  };

  return (next) => (action) => {
    try {
      switch (action.type) {
        case visibilityStart.toString(): {
          initVisibility();
          break;
        }
        case visibilityStop.toString(): {
          removeVisibility();
          break;
        }
      }
    } catch (exception) {
      Sentry.captureException(
        new Error('Visibility: middleware exception caught'),
        { extra: { exception } },
      );
    }

    return next(action);
  };
};
